import React, { useCallback } from 'react';
import { shape, string, number, func, arrayOf, array } from 'prop-types';

const Result = ( props ) => {

    const { page, prev, next, paginationButtons, divisor, result } = props;

    const totalPages = Math.ceil( result.results.length / divisor );

    const renderResults = useCallback( () => {

        if ( result.title === 'Digest' ) {

            return result.results.map( ( item ) => mapRender( item ) );

        }

        return result.results.slice( ( page - 1 ) * divisor, page * divisor ).map( ( item ) => mapRender( item ) );

    } );

    const mapRender = ( item ) => {

        const resultData = item.attributes;

        return (
            <a key={ item.id } href={ resultData.url } className='data-periodic-release-archive-filter-special-anim'>
                { item.attributes.icon.text.toLowerCase() !== 'page' ? ( <div className='data-periodic-release-archive-filter-arrow-anim-box'>
                    <div className='data-periodic-release-archive-filter-arrow'>
                        <svg focusable width='6' height='8' viewBox='0 0 6 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path d='M2.54572 0.454545C2.54572 0.203507 2.74923 0 3.00027 0L3.32071 7.14056C3.23883 7.22195 3.12612 7.27236 3.00163 7.27273L3.00027 7.27273L2.9989 7.27273C2.93777 7.27255 2.87947 7.2603 2.82627 7.23824C2.77388 7.21656 2.72472 7.18466 2.68183 7.14255L2.67853 7.13927L0.860672 5.32141C0.683161 5.1439 0.683161 4.8561 0.860672 4.67859C1.03818 4.50108 1.32599 4.50108 1.5035 4.67859L2.54572 5.72081V0.454545Z' fill='#011E4D' />
                            <path d='M3.00027 0L3.3219 7.13937L5.13986 5.32141C5.31737 5.1439 5.31737 4.8561 5.13986 4.67859C4.96235 4.50108 4.67455 4.50108 4.49704 4.67859L3.45481 5.72081V0.454545C3.45481 0.203507 3.2513 0 3.00027 0Z' fill='#011E4D' />
                        </svg>
                    </div>

                    <div className='data-periodic-release-archive-filter-bucket'>
                        <svg focusable width='10' height='4' viewBox='0 0 10 4' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path d='M0.908647 0.818176C0.657608 0.818176 0.454102 1.02168 0.454102 1.27272V2.63636C0.454102 3.38947 1.06462 3.99999 1.81774 3.99999H8.18137C8.93449 3.99999 9.54501 3.38947 9.54501 2.63636V1.27272C9.54501 1.02168 9.3415 0.818176 9.09046 0.818176C8.83943 0.818176 8.63592 1.02168 8.63592 1.27272V2.63636C8.63592 2.8874 8.43241 3.0909 8.18137 3.0909H1.81774C1.5667 3.0909 1.36319 2.8874 1.36319 2.63636V1.27272C1.36319 1.02168 1.15969 0.818176 0.908647 0.818176Z' fill='#011E4D' />
                        </svg>
                    </div>
                </div> ) : '' }
                <div className='data-periodic-release-archive-filter-words'>
                    <p>{ resultData.title }</p>
                    <div className='lgwf-underline-anim'>
                        <div></div>
                    </div>
                </div>

                <p className='data-periodic-release-archive-filter-filetitle'>{ resultData.icon.text }</p>

                <img src={ resultData.icon.src } alt={ resultData.icon.alt }></img>
            </a>
        );

    };

    return (
        <div className='data-periodic-release-archive-filter-result'>
            {
                result.results.length > 0 &&
                <h3>{ result.title }</h3>
            }

            <div className='data-periodic-release-archive-filter-special-anim-wrapper'>
                { renderResults() }
            </div>

            {
                result.results.length > divisor &&
                <div className='lgwf-pagination'>
                    {
                        page - 1 > 0 &&
                        <a onClick={ prev }>
                            <img className='lgwf-prev' src='/assets/images/svg/icon-utility/arrow-left.svg' alt=''></img>
                        </a>
                    }

                    {
                        paginationButtons.map( ( i ) => i )
                    }

                    {
                        page < totalPages &&
                        <a onClick={ next }>
                            <img className='lgwf-next' src='/assets/images/svg/icon-utility/arrow-right.svg' alt=''></img>
                        </a>
                    }
                </div>
            }

        </div>
    );

};

Result.propTypes = {
    page: number.isRequired,
    prev: func.isRequired,
    next: func.isRequired,
    update: func.isRequired,
    paginationButtons: array,
    divisor: number.isRequired,
    result: shape( {
        title: string.isRequired,
        results: arrayOf( shape( {
            attributes:
                shape( {
                    title: string.isRequired,
                    url: string.isRequired,
                    year: string.isRequired,
                    icon: shape( {
                        src: string.isRequired,
                        alt: string.isRequired,
                        text: string.isRequired
                    } )
                } )
        } ) ).isRequired
    } ).isRequired
};

export default Result;